import React, { useState, useRef, useContext, useEffect, useCallback } from 'react';

import { WrapperStyled } from './styles';
import { Outlet } from "react-router-dom";
import { Header } from './Header';
import { MenuNav } from './MenuNav';
import { ContentContext } from '../../context/ContentContext';
import { TiChevronRight } from "react-icons/ti";
import { useNavigate, useLocation } from 'react-router-dom';
    

const Root = (props) => {
  
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { menu,
          getMenu,
          qrResult } = useContext(ContentContext)
  
  const [ sidebarOpen, setSidebarOpen ] = useState(false);
  const [ withMarginRigth, setWithMarginRigth ] = useState(false);
  const [ showNav, setShowNav ] = useState(false);

  const timeOutSidebar = useRef(null);

  const handleOpenSidebar = () => {
    if(timeOutSidebar.current){
      clearTimeout(timeOutSidebar.current);
    }
    setSidebarOpen(!sidebarOpen)
  }
  

  const handleLeaveSidebar = () => {
    timeOutSidebar.current = setTimeout(() => { setSidebarOpen(false); }, 500);
    
  }
  const handleEnterSidebar = () => {
    if(timeOutSidebar.current){
      clearTimeout(timeOutSidebar.current);
    }
    setSidebarOpen(true)
  }
  

  useEffect(() => {

    getMenu();
  
    return () => {}
  }, [])
  
  
  if(!menu){
    return null;
  }
    
  return (
    <WrapperStyled>
      <Header
        showNav={showNav}
        setShowNav={setShowNav}
      />
      {/* <Header 
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      /> */}
      {showNav ?
      <MenuNav 
        showNav={showNav}
        setShowNav={setShowNav}
      /> : ""}
      <div className='content'>

        {/* <div className={`sidebar ${sidebarOpen ? " open" : ""}`}>
          <MenuNav 
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            menu={menu}
          />
        </div> */}
        <div className='inner'>
          <Outlet />
        </div>
      </div>
    </WrapperStyled>
  )
  
}
export default Root;
